import { useState } from "react";
import { toast } from "sonner";
import { FileDown, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { downloadNote, formatError } from "@/lib/api";

export function NoteButton({ order, className = "" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadNote(order);
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button type="button" variant="outline" onClick={run} disabled={busy} className={`rounded-full ${className}`} data-testid="btn-download-note">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />} Nota de serviço (PDF)
    </Button>
  );
}
